import styled from 'styled-components';

export const StepsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 2rem;
`;
